import React, { useState } from "react";
import Button from "../Button";

const DownloadButton = ({ onClick, ...rest }) => {
  const [loading, setLoading] = useState(false);

  const download = async () => {
    setLoading(true);

    await onClick();

    setLoading(false);
  }

  return (
    <Button
      loading={loading}
      onClick={download}
      {...rest}
    />
  );
};

export default DownloadButton;
